import gql from 'graphql-tag';

export const appInfo = gql`
  query ($applicationId: Int) {
    appInfo(applicationId: $applicationId) {
      count {
        device {
          iBeacons
          eddystones
          readers
          bluetoothHubs
          gateways
          sensors
          nfcTags
          lightings
        }
        site {
          advertisements
          coupons
          pollings
          votings
          deepLinks
        }
      }
      range {
        iBeacon {
          uuid
          major
          minor
        }
        eddystone {
          namespace
          instance
        }
      }
    }
  }
`
